import { transformCartWishlistItemsRequest, transformCatalogProductResponse, transformProductOptions } from '../transformers/product/index.js';
import { transformBundleOptions } from '../transformers/bundleOptions/index.js';
import { transformConfigurableOptions } from '../transformers/configurableOptions/index.js';
import { transformCustomOptions } from '../transformers/customOptions/index.js';
import { transformGroupedOptions } from '../transformers/groupedOptions/index.js';
import { transformGiftCardOptions } from '../transformers/giftcardOptions/index.js';
import { transformTotals } from '../transformers/cartCheckout/index.js';

const transformSalesCartItemsRequest = (item)=>transformCartWishlistItemsRequest(item);
const transformSalesCartItemsResponse = ({ id , sku , parent_sku , name , metadata , product_type , product_data , product_options , additional_info , qty , price , totals  })=>{
    const productData = product_data ? transformCatalogProductResponse(product_data) : null;
    const transformedMetadata = {
        configurableOptions: transformConfigurableOptions(metadata?.configurable_options, product_data?.variants),
        customOptions: transformCustomOptions(metadata?.custom_options),
        bundleOptions: transformBundleOptions(metadata?.bundle_options),
        groupedOptions: transformGroupedOptions(metadata?.grouped_options),
        giftcardOptions: transformGiftCardOptions(metadata?.giftcard_item_option, productData)
    };
    return {
        id,
        sku,
        parentSku: parent_sku,
        name,
        metadata: transformedMetadata,
        productType: product_type,
        productData,
        productOptions: transformProductOptions(product_options, productData, transformedMetadata),
        salesRule: {
            type: additional_info?.filoblu_salesrule_type || null,
            autoAdd: additional_info?.filoblu_salesrule_auto_add || null,
            tag: additional_info?.filoblu_salesrule_tag || null
        },
        qty,
        totals: {
            price: totals?.price ?? price,
            subtotal: totals?.subtotal ?? price * qty
        }
    };
};
const transformItems = (data)=>{
    const transformedArray = data.map((item)=>transformSalesCartItemsResponse(item));
    // sort products by DESC order
    const sortedArray = transformedArray.sort((a, b)=>a.id - b.id);
    // move free items at the end of the cart
    const freeItems = sortedArray.filter((item)=>item.salesRule?.type === 'free_gift');
    const itemsNotFree = sortedArray.filter((item)=>item.salesRule?.type !== 'free_gift');
    return itemsNotFree.concat(freeItems);
};
const transformFreeGift = ({ ids , rule_id , offered_products , max_products_for_sku , taken_products , source , title , description  })=>({
        entityIds: ids,
        ruleId: rule_id,
        maxProductNumberSelections: offered_products,
        maxProductsForSku: parseInt(max_products_for_sku || offered_products),
        currentProductNumberSelections: taken_products,
        entityType: source,
        title,
        description
    });
const transformGetSalesCartItemsResponse = ({ id , items , totals , cart_is_saleable , is_virtual , free_gifts , giftcard_not_allowed , force_save_cc , giftwrap_not_allowed , giftmessage_not_allowed , items_qty , free_shipping_info , is_shipping_estimated  })=>({
        id,
        items: transformItems(items),
        freeGifts: free_gifts.map((freeGift)=>transformFreeGift(freeGift)),
        totals: transformTotals(totals),
        isSaleable: cart_is_saleable,
        isVirtual: is_virtual,
        forceSaveCard: force_save_cc,
        giftCardNotAllowed: giftcard_not_allowed,
        giftWrapNotAllowed: giftwrap_not_allowed,
        giftMessageNotAllowed: giftmessage_not_allowed,
        itemsQty: items_qty,
        freeShipping: {
            amountLeft: free_shipping_info?.amount_left,
            threshold: free_shipping_info?.threshold
        },
        isShippingEstimated: is_shipping_estimated ?? false
    });
const transformSalesCartMeTotalsResponse = (totals)=>transformTotals(totals);
const transformPatchSalesCartItemsResponse = (item)=>transformSalesCartItemsResponse(item);

export { transformGetSalesCartItemsResponse, transformPatchSalesCartItemsResponse, transformSalesCartItemsRequest, transformSalesCartItemsResponse, transformSalesCartMeTotalsResponse };
